<template>
  <section id="section" class="slideDown">
    <div class="back" @click="back()">{{ $t('admin.section.back') }}</div>
    <div class="container">
      <div class="content">
        <h3 class="title">
          <span v-if="section.id == -1">{{ $t('general.create') }}</span><span v-else>{{ $t('general.edit') }}</span
          ><span>{{ $t('admin.section.section') }}</span>
        </h3>

        <div class="details">
          <div class="subtitle">{{ $t('general.subtitle') }}</div>
          <v-form ref="form_section" v-model="valid">
            <v-text-field
              v-model="section.name"
              :rules="requiredRules"
              :label="$t('general.name')"
              required
            ></v-text-field>
            <v-select
              v-model="section.type"
              :items="types"
              hide-no-data
              :label="$t('general.category_type')"
              :rules="requiredRules"
              required
            ></v-select>
            <v-switch v-model="sectionStatusBoolean" :label="$t('admin.section.active')"></v-switch>

            <div v-if="section.type != -1">
              <div class="subtitle">{{ $t('admin.section.subtitle') }}</div>
              <!-- <v-card-title>
                      
                      <v-spacer></v-spacer>
                      <v-text-field  v-model="search" append-icon="search" label="Buscar categoría" single-line hide-details></v-text-field>
                  </v-card-title>
                    <v-data-table :headers="headers" :items="sections" class="elevation-1" :no-results-text="message_not_found" :rows-per-page-items="rowsPerPage" :search="search"
                :rows-per-page-text="message_rows_per_page">
                    <template v-slot:headers="props">
                      <tr>
                        <th
                          v-for="header in props.headers"
                          :key="header.text"
                          :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                          @click="changeSort(header.value)"
                        >
                          <v-icon small>arrow_upward</v-icon>
                          {{ header.text }}
                        </th>
                      </tr>
                  </template>
                    <template v-slot:items="props">
                      <template v-if="props.item.visible && ( section.type == -1 || section.type == props.item.type )">
                        <tr @click="select( props.item )" :class="{ 'selected': props.item.id == parent_id }">
                          <td style="margin-left: 20px;" :class="{'child':props.item.level == 1, 'child2':props.item.level == 2}"><span v-for="n in props.item.level" class="separator">a</span><v-icon v-if="props.item.level != 0">subdirectory_arrow_right</v-icon><v-icon v-if="props.item.childs.length > 0 && props.item.selected" @click="less( props.item.id )">expand_less</v-icon><v-icon v-if="!props.item.selected && props.item.childs.length > 0" @click="expand( props.item.id )">expand_more</v-icon></td>
                          <td style="text-align:left" :class="{'child':props.item.level == 1, 'child2':props.item.level == 2}">{{ props.item.name }}</td>
                          <td style="text-align:left" :class="{'child':props.item.level == 1, 'child2':props.item.level == 2}">{{ props.item.path }}</td>
                        </tr>
                      </template>
                    </template>
                </v-data-table> -->
              <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  :label="$t('general.search_category')"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                id="categories"
                :custom-filter="filterTable"
                :headers="headers"
                :items="sections"
                class=""
                :no-results-text="message_not_found"
                :rows-per-page-items="rowsPerPage"
                :search="search"
                :pagination.sync="pagination"
                :rows-per-page-text="message_rows_per_page"
              >
                <template v-slot:items="props">
                  <template>
                    <tr @click="select(props.item)">
                      <td>
                        <v-checkbox
                          :input-value="props.item.id == parent_id"
                          primary
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td style="text-align:left">
                        <div class="name">{{ props.item.name }}</div>
                        <div class="path">{{ props.item.path }}</div>
                      </td>
                    </tr>
                  </template>
                </template>
              </v-data-table>
            </div>
          </v-form>
        </div>

        <div v-show="error_message" class="message error fadeIn">
          {{ $t('admin.section.select_category') }}
        </div>
        <div class="buttons">
          <v-btn color="success" @click="save">{{ $t('general.save') }}</v-btn>
          <v-btn color="cancel" @click="back">{{ $t('general.back') }}</v-btn>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import i18n from "@/i18n";
export default {
  props: {},
  components: {},
  data() {
    return {
      valid: false,
      requiredRules: [v => !!v || i18n.t("general.obligatory_field")],
      // headers: [
      //     { text: 'Nombre', value: 'name' },
      //     { text: 'Ruta', value: "name" }
      // ],
      headers: [
        { text: "", value: "selected", width: "30px", class: "condensed" },
        { text: i18n.t('general.name'), value: "name", width: "100%" }
      ],
      search: "",
      message_not_found: i18n.t('general.message_not_found'),
      message_rows_per_page: i18n.t('general.message_rows_per_page'),
      rowsPerPage: [10],
      pagination: {
        sortBy: "name"
      },
      section: JSON.parse(
        JSON.stringify(this.$store.getters["files/getCurrentSection"])
      ),
      types: [
        { value: "1", text: i18n.t('general.section_types.national') },
        { value: "2", text: i18n.t('general.section_types.local') },
        { value: "3", text: i18n.t('general.section_types.support') },
        { value: "5", text: i18n.t('general.section_types.best_practice') }
      ],
      parent_id: -1,
      parent_type: -1,
      parent_level: 0,
      error_message: false
    };
  },
  created() {
    var id = this.section.id != -1 ? this.section.id : "add";
    this.$router.push({ name: "sections_edit", params: { id: id } });

    this.parent_id = this.section.parent_id;

    var self = this;
    this.$store.dispatch("files/loadCategories", {}).then(function() {
      self.$store.commit("files/selectCategory", false);
    });
  },
  computed: {
    languages() {
      var languages = ObjectToArray(this.$store.state.languages);
      var aLanguages = [];

      languages.forEach(lang => {
        aLanguages.push({ text: lang.fullname, value: lang.id });
      });
      return aLanguages;
    },
    type() {
      return this.section.type;
    },
    sectionStatusBoolean: {
      get() {
        return this.section.status == 1 || this.section.status === true;
      },
      set(value) {
        this.section.status = value ? 1 : 0;
      }
    },
    sections() {
      console.log(this.$store.getters["files/getCategories"]());
      var sections = ObjectToArray(
        JSON.parse(JSON.stringify(this.$store.getters["files/getCategories"]()))
      );

      var aSections = [];
      sections.forEach(section => {
        var childs = ObjectToArray(section.childs);
        section.visible = true;
        section.childs = childs;
        section.level = parseInt(section.level);
        section.path = section.name;
        section.selected = false;
        if (section.level < 2 && section.type == this.section.type) {
          aSections.push(section);
        }
        childs.forEach(child => {
          child.visible = child.visible || false;
          var childs2 = ObjectToArray(child.childs);
          child.childs = childs2;
          child.level = parseInt(child.level);
          child.path = section.name + " > " + child.name;
          child.selected = false;
          if (child.level < 2 && child.type == this.section.type) {
            aSections.push(child);
          }
          childs2.forEach(child2 => {
            child2.visible = child2.visible || false;
            child2.level = parseInt(child2.level);
            child2.selected = false;
            child2.path =
              section.name + " > " + child.name + " > " + child2.name;
            if (child2.level < 2 && child2.type == this.section.type) {
              aSections.push(child2);
            }
          });
        });
      });
      return aSections;
    }
  },
  methods: {
    back() {
      this.$store.commit("files/unsetCurrentSection");
      this.$router.push({ name: "sections" });
    },
    save() {
      var result = "";
      if (this.$refs.form_section.validate() && this.section.type != -1) {
        var self = this;
        this.section.status = this.section.status ? 1 : 0;
        this.section.url = this.section.name
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/ /g, "")
          .toLowerCase();

        while (result == "" || result != undefined) {
          result = Object.values(this.sections).find(obj => {
            return obj.url === this.section.url;
          });
          if (result != undefined) {
            this.section.url = this.section.url + "1";
          }
        }

        this.section.level = this.parent_level;

        this.$store
          .dispatch("files/uploadSection", this.section)
          .then(function() {
            self.$store.commit("files/unsetCurrentSection");
            self.$store.dispatch("files/loadCategories", {});
            self.$router.push({ name: "sections" });
          });
      } else {
        this.error_message = true;
        var self = this;
        setTimeout(function() {
          self.error_message = false;
        }, 4000);
      }
    },
    expand(id) {
      this.$store.commit("files/expandSection", id);
    },
    less(id) {
      this.$store.commit("files/lessSection", id);
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    select(section) {
      if (section.level < 2) {
        if (this.parent_id != -1 && this.parent_id == section.id) {
          this.parent_id = -1;
          this.parent_type = -1;
          this.section.parent_id = -1;
        } else {
          this.parent_id = section.id;
          this.section.parent_id = section.id;
          this.parent_type = section.type;
          this.parent_level = section.level + 1;
          this.section.type = section.type;
        }
      }
    },
    filterTable(items, search, filter) {
      var aItems = [];
      items.forEach(item => {
        if (
          filter(item.name, search.toLowerCase()) ||
          filter(item.path, search.toLowerCase())
        ) {
          aItems.push(item);
        } else {
          Object.values(item.childs).forEach(child => {
            if (
              filter(child.name, search.toLowerCase()) ||
              filter(child.path, search.toLowerCase())
            ) {
              aItems.push(item);
            } else {
              Object.values(child.childs).forEach(child2 => {
                if (
                  filter(child2.name, search.toLowerCase()) ||
                  filter(child2.path, search.toLowerCase())
                ) {
                  aItems.push(item);
                }
              });
            }
          });
        }
      });
      return aItems;
    }
  },
  watch: {
    type() {
      if (this.parent_id != -1 && this.parent_type != this.section.type) {
        this.parent_id = -1;
        this.parent_type = -1;
        this.section.parent_id = -1;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.child {
  border-top: 2px solid var(--main_color);
}
.child2 {
  border-top: 2px solid var(--secondary_color);
}
.separator {
  float: left;
  width: 30px;
  opacity: 0;
}
.selected {
  background-color: var(--secondary_color) !important;
}
#file {
  max-width: 1200px;
  margin: 0 auto;
  margin-bottom: 50px;
}

.back {
  background: url(/img/left-arrow.svg) no-repeat left center;
  text-align: left;
  margin-bottom: 20px;
  padding-left: 25px;
  cursor: pointer;
}
.container {
  width: 100%;
  overflow: hidden;

  .image {
    width: 40%;
    float: left;
    padding: 0 40px;

    img,
    .addthumb {
      width: 95%;
      border: 1px solid #ccc;
      min-height: 250px;
      position: relative;
      cursor: pointer;
    }

    .addthumb div {
      width: 100%;
      display: block;
      top: 35%;
      position: absolute;
      text-align: center;
    }
    .addthumb .text {
      top: 55%;
    }
  }

  .content {
    width: 60%;
    float: left;
    text-align: left;
    padding: 0 25px;

    .title {
      margin: 10px 0;
      font-size: 20pt;
      font-family: Speedee-Bold;
    }
    .details {
      margin: 20px 0;

      .subtitle {
        font-family: Speedee-Bold;
        color: #bbb;
        margin-bottom: 10px;
      }
      .item {
        font-size: 11pt;

        .label {
          margin-right: 5px;
        }
        .value {
          font-family: Speedee-Bold;
        }
      }
    }

    .buttons {
      margin: 35px 0;

      .bttn {
        width: 100%;
        max-width: 300px;
        overflow: hidden;
        margin-bottom: 5px;
        line-height: 30px;
        cursor: pointer;
        display: block;
        color: #333;

        .icon {
          width: 30px;
          height: 30px;
          background: #ccc;
          display: inline-block;
          float: left;
          overflow: hidden;
        }
        span {
          display: inline-block;
          float: left;
          padding-left: 5px;
          font-size: 11pt;

          &:hover {
            font-family: Speedee-Bold;
          }
        }
        &.download {
          border-top: 2px solid var(--main_color);

          .icon {
            background: url(/img/download.svg) no-repeat center
              var(--main_color);
            background-size: 18px;
          }
        }
        &.order {
          border-top: 2px solid #ccc;
          .icon {
            background: url(/img/edit.svg) no-repeat center #ccc;
            background-size: 18px;
          }
        }
      }
    }
    .desc {
      font-size: 10pt;
      margin-top: 25px;
      margin-bottom: 5px;
      display: block;
    }
    .url {
      width: 100%;
      padding: 5px;
      font-size: 11pt;
      border-radius: 5px;
      border: 1px solid #ccc;
    }
  }
}
</style>
